import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Subject } from 'rxjs';
import _ from 'lodash';
@Component({
  selector: 'app-my-school-admin',
  templateUrl: './my-school-admin.component.html',
styleUrls: ['./my-school-admin.component.css', 
'../../pages/contact-us/contact-us.component.css',
'../new-church-application/new-church-application.component.css']
})
export class MySchoolAdminComponent implements OnInit, OnDestroy {
  @Input() orgId: string;
  leaving = new Subject()
  org;
  constructor(
    private db: AngularFireDatabase
  ) { }

  ngOnInit(): void {
    this.db.object(`/Organizations/${this.orgId}`)
    .valueChanges()
    .takeUntil(this.leaving)
    .subscribe(org => {
      this.org = org
    })
  }
  ngOnDestroy(){
    this.leaving.next()
  }

}
